import { PENSION_ANNUITY_LIMITS } from "shared/CalculatorLimits";

type Params = {
	annuity: number | null;
	deposit: number | null;
};

export const hasPensionAnnuityInputs = ({ annuity, deposit }: Params) =>
	annuity !== null &&
	annuity > 0 &&
	annuity <= PENSION_ANNUITY_LIMITS.annuityMax &&
	deposit !== null &&
	deposit >= 0 &&
	deposit <= PENSION_ANNUITY_LIMITS.depositMax;
